<template>
    <div class="hello">
      <hr/>
      <h1> ZCLAIQCC </h1>
      <h2> {{ msg }} </h2>
    </div>
</template>

<script>
export default {
  name: 'helloVue',
  data () {
    return {
      msg: 'HelloVue'
    }
  }
}
</script>

<style scoped>

</style>
